export const getSentryDsn = (): string => process.env.REACT_APP_SENTRY_DSN!
